import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const CELL_STYLE = {
  fontWeight: 600,
  backgroundColor: 'grey.100',
  borderRight: '1px solid',
  borderColor: 'divider',
  py: 1,
  px: 1.5,
} as const;

export const PayrollSpreadsheetHeader: React.FC = () => (
  <TableRow>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 140 }}>직원명</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 80, textAlign: 'right' }}>근무</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 100, textAlign: 'right' }}>기본급</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 90, textAlign: 'right' }}>주휴수당</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 90, textAlign: 'right' }}>연장/야간/휴일</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 100, textAlign: 'right' }}>총급여</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 90, textAlign: 'right' }}>공제</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 90, textAlign: 'right' }}>원천세</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 80, textAlign: 'right' }}>지방세</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 110, textAlign: 'right' }}>실수령액</TableCell>
    <TableCell sx={{ ...CELL_STYLE, width: 90 }} />
  </TableRow>
);
